<ng-container *msShowInEpcot="{ showInEpcot: false, module: module }">
    <i class="theme-success-i"></i>
    <span class="betslip-result-header-message" [msAutomation]="'betslip-confirmation-success-message'">{{ viewModel.resultMessage }}</span>
    <span class="betslip-result-header-good-luck">{{ viewModel.goodLuckMessage }}</span>
</ng-container>
<ng-container *msShowInEpcot="{ showInEpcot: true, module: module }">
    <ms-epcot-notification [message]="notificationMessage" [notificationType]="'success'"></ms-epcot-notification>
</ng-container>
